export default __webpack_public_path__ + "static/media/default.0ff6397515196c5d43b7fc1684a58335.png";